import React from "react";
import styled from "styled-components";

const FileUploadWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	margin-top: 10px;
`;

const FileButton = styled.button`
	padding: 10px 20px;
	border: none;
	border-radius: 5px;
	background-color: #007bff;
	color: #fff;
	cursor: pointer;
	font-size: 14px;
	&:hover {
		background-color: #0056b3;
	}
`;

const FileName = styled.span`
	font-size: 14px;
	color: #333;
`;

const RemoveButton = styled.button`
	border: none;
	background: none;
	font-size: 14px;
	color: #ff4d4d;
	cursor: pointer;
`;

export default function FileInput({
	index,
	name,
	formData,
	setFormData
}) {
	const handleFileChange = (e, name, index) => {
		const file = e.target.files[0];
		setFormData((prevData) =>
			prevData.map((item, idx) => {
				if (idx === index) {
					return { ...item, [name]: file };
				}
				return item;
			})
		);
	};

	const handleRemoveFile = (name, index) => {
		setFormData((prevData) =>
			prevData.map((item, idx) => {
				if (idx === index) {
					return { ...item, [name]: null };
				}
				return item;
			})
		);
	};

	return (
		<FileUploadWrapper>
			{!formData[index][name] ? (
				<>
					<FileButton onClick={() => document.getElementById(`file-${index}`).click()}>
						Add File
					</FileButton>
					<input
						type="file"
						id={`file-${index}`}
						style={{ display: "none" }}
						onChange={(e) => handleFileChange(e, name, index)}
					/>
				</>
			) : (
				<>
					<FileName>{formData[index][name].name}</FileName>
					<RemoveButton onClick={() => handleRemoveFile(name, index)}>×</RemoveButton>
				</>
			)}
		</FileUploadWrapper>
	)
}